export default "__VITE_ASSET__D8n9rI25__"